export const websiteLink = '';
export const tgLink = 'https://t.me/zephyrbrowser';
export const xLink = 'https://x.com/zephyrbrowser';
export const ViewDocs = '/docs';
export const getstarted = '#';
export const download = '#';
export const dexScreenerLink = '#';
export const uniSwapLink = '#';
export const CoinMarketCap ='#'
export const Coingecko = '#'
export const supply = '#';
export const CA = '#';
export const Buytax = '#';
export const Selltax = '#';
export const helpcenter = '#';
export const Github = '#';